(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["albeux-cinematic-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var tile = '';
  function grainTile() {
    if (tile) return tile;
    var c = document.createElement('canvas');
    c.width = c.height = 256;
    var x = c.getContext('2d');
    var im = x.createImageData(256, 256);
    var d = im.data;
    for (var i = 0; i < 65536; i++) {
      var v = Math.random() < 0.5 ? 0 : 255;
      d[i * 4] = d[i * 4 + 1] = d[i * 4 + 2] = v;
      d[i * 4 + 3] = 255;
    }
    x.putImageData(im, 0, 0);
    tile = c.toDataURL('image/png');
    return tile;
  }
  function splitHeadline(h) {
    var lineEl = h.querySelector('.acine__line');
    if (!lineEl) return;
    var text = lineEl.textContent.trim();
    h.setAttribute('aria-label', text);
    lineEl.textContent = '';
    lineEl.setAttribute('aria-hidden', 'true');
    var n = 0;
    text.split(' ').filter(Boolean).forEach(function (w, wi) {
      if (wi) lineEl.appendChild(document.createTextNode(' '));
      var word = document.createElement('span');
      word.className = 'acine__word';
      w.split('').forEach(function (chr) {
        var s = document.createElement('span');
        s.className = 'acine__ch';
        s.style.setProperty('--i', n++);
        s.textContent = chr;
        word.appendChild(s);
      });
      lineEl.appendChild(word);
    });
  }
  function setup(root) {
    if (root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');
    var g = root.querySelector('[data-acine-grain]');
    if (g) g.style.backgroundImage = 'url(' + grainTile() + ')';
    var h = root.querySelector('.acine__headline');
    if (h) splitHeadline(h);
    var next = root.querySelector('[data-acine-next]');
    if (next) next.addEventListener('click', function () {
      var wrap = root.closest('.shopify-section');
      var n = wrap && wrap.nextElementSibling;
      if (n) n.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
    if (reduce) { root.classList.add('is-playing', 'is-done'); return; }
    var plate = root.querySelector('.acine__plate');
    var img = root.querySelector('.acine__img');
    var started = false;
    function go() {
      if (started) return;
      started = true;
      requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-playing'); }); });
    }
    var ready = [];
    if (img) ready.push(img.decode ? img.decode().catch(function () {}) : Promise.resolve());
    if (document.fonts && document.fonts.ready) ready.push(document.fonts.ready);
    var wait = Promise.race([Promise.all(ready), new Promise(function (r) { setTimeout(r, 2500); })]);
    wait.then(function () {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          if (es[0].isIntersecting) { io.disconnect(); go(); }
        }, { threshold: 0.2 });
        io.observe(root);
      } else { go(); }
    });
    if (plate) plate.addEventListener('animationend', function (e) {
      if (e.target === plate) root.classList.add('is-done');
    });
  }
  function init() { document.querySelectorAll('[data-acine]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
